var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"floating-btn btn no-outline",on:{"click":_vm.updateActivity}},[_c('span',{staticClass:"d-flex justify-content-center align-items-center"},[_c('img',{attrs:{"src":_vm.floppyDisk}})])])}
var staticRenderFns = []

export { render, staticRenderFns }